const ENImportValues = {
	"Documentos delimitados":"Delimited documents",
	"Selecione os arquivos que deseja importar para o sistema":"Select the files you want to import into the system",
	"Podem ser arquivos delimitados TXT ou CSV e planilhas XLS, XLSX ou ODS":"They can be TXT or CSV delimited files and XLS, XLSX or ODS spreadsheets",
	"Acesse o manual completo":"Access the complete manual",
	"Arquivos compactados":"Compressed files",
	"Para facilitar o envio, compacte os arquivos em extensões .zip ou .rar para enviar":"To facilitate sending, compress the files in .zip or .rar extensions to send",
	"Máximo 10Mb":"10Mb Max",
	"Cada arquivo poderá conter no máximo 10Mb de tamanho":"Each file can contain a maximum size of 10Mb",
	"Nome do arquivo":"File Name",
	"Processados":"Processed",
	"Importação manual":"Manual import",
	"Importados":"Imported",
	"Erro ao importar arquivos":"Error on import files",
	"Código campo":"Field code",
	"Código périodo":"Period code",
	"Código tipo de período":"Period type code",
	"Posição das colunas":"Column position"

};

export default ENImportValues;
